import ExtraHotels from './extra-hotels-component';

import './extra-hotels.scss';

const MODULE_NAME = 'app.hotels.extra-hotels';
const module = angular.module(MODULE_NAME, [])
    .directive(ExtraHotels.DIRECTIVE_NAME, ExtraHotels);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/extra-hotels/extra-hotels-module.js